import { Component } from '@angular/core';

@Component({
  selector: 'nb-auth-block',
  styleUrls: ['./auth-block.component.scss'],
  template: `
    <ng-content></ng-content>
  `,
})
export class AuthBlockComponent {
}



// WEBPACK FOOTER //
// ./src/app/auth/components/auth-block/auth-block.component.ts